import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const SwitchView = ({ setDrugsView, viewName, label }) => {
  return (
    <button
      type="button"
      onClick={() => setDrugsView(viewName)}
      className="symptom-ui-button symptom-ui-button--secondary switch-view-button"
    >
      {label} <FontAwesomeIcon icon={faArrowRight} />
    </button>
  );
};

export default SwitchView;
